import { FilterProtocolDTO } from "../DTO/filterProtocolDTO";
import { FieldDefinition } from "./fieldDefinition";
import { FilterRule } from "./filterRule";
import { FilterRuleDefinition } from "./filterRuleDefinition";

export class FilterProtocol {

    public id!: number;
    public sequenceNo!: number;
    public filterRules!: FilterRule[];
    public filterOr!: boolean;

    public filterInfo:string='';

    constructor(){
        this.filterRules = new Array(); //for filter protocols we do allow an empty rule array so we can create an empty protocol to override in cofiguration
        this.filterOr = false;
    }

    public createInputField(fieldDefinitions:FieldDefinition[]){
        if(this.filterRules) {
            this.filterRules.forEach(fr=>{
                fr.createInputField(fieldDefinitions);
                this.filterInfo += fr.inputField?.name + '; ';
            });
        }
        else{
            this.filterInfo="no rules defined";
        }
    }

    public static mapFromDTO(param:FilterProtocolDTO):FilterProtocol{ 
        if (!param) throw new Error("parameter is null")
        let obj = new FilterProtocol();
        try
        {
            obj.id = param.id;
            obj.sequenceNo = param.sequenceNo;
            if(param.filterRules?.length>0) obj.filterRules = param.filterRules.map(fr=>FilterRule.mapFromDTO(fr));
            obj.filterOr = param.filterOr;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:FilterProtocol):FilterProtocolDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new FilterProtocolDTO();
        try
        {
            dto.id = param.id;
            dto.sequenceNo = param.sequenceNo;
            dto.filterRules = param.filterRules.map(fr=>FilterRule.mapToDTO(fr));
            dto.filterOr = param.filterOr;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    //use DTO to create a deep copy
    get clone():FilterProtocol{
        //memorize used filterRuleDefinitions first
        let usedFilterRuleDefinitions:FilterRuleDefinition[]=[];
        this.filterRules.forEach(fr=>{
            if(usedFilterRuleDefinitions.findIndex(frd=>frd.id==fr.filterRuleDefinition.id)==-1){
                usedFilterRuleDefinitions.push(fr.filterRuleDefinition);
            }
        });
        let mappedFilterProtocol=FilterProtocol.mapToDTO(this);
        mappedFilterProtocol.id=0;
        mappedFilterProtocol.filterRules.forEach(r=>{
            r.id=0;
        });
        let mapFromDTOFilterProtocol = FilterProtocol.mapFromDTO(mappedFilterProtocol);
         //relate filterRuleDefinitions with clone
         mapFromDTOFilterProtocol.filterRules.forEach(fr=>{
            fr.filterRuleDefinition=usedFilterRuleDefinitions.find(frd=>frd.id==fr.filterRuleDefinitionId)!;
        });
        return mapFromDTOFilterProtocol;
    }

    
}